import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import { closeGAOnboarding, useIsGAOnboardingOpen } from '../betaGASharedState';

export const LazyGAOnboardingModal: FunctionComponent = () => {
  const PPOnboardingModal = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "personal-productivity-onboarding-modal" */ './PPOnboardingModal'
      ),
    { namedImport: 'PPOnboardingModal', preload: true },
  );
  const shouldShowOnboarding = useIsGAOnboardingOpen();

  return (
    shouldShowOnboarding && (
      <Suspense fallback={null}>
        <ChunkLoadErrorBoundary fallback={null}>
          <PPOnboardingModal onComplete={closeGAOnboarding} />
        </ChunkLoadErrorBoundary>
      </Suspense>
    )
  );
};
